// extracted by mini-css-extract-plugin
module.exports = {"desc":"_1565","content":"_6817"};